import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateInventoryItemMutationVariables = Types.Exact<{
  input: Types.CreateInventoryItemCommandInput;
}>;


export type CreateInventoryItemMutation = { __typename?: 'Mutation', createInventoryItem: { __typename?: 'InventoryItemPayload', inventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AdjustInventoryItemMutationVariables = Types.Exact<{
  input: Types.SetInventoryItemInput;
}>;


export type AdjustInventoryItemMutation = { __typename?: 'Mutation', adjustInventoryItem: { __typename?: 'InventoryItemPayload', inventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type IncrementInventoryItemMutationVariables = Types.Exact<{
  input: Types.IncrementInventoryItemInput;
}>;


export type IncrementInventoryItemMutation = { __typename?: 'Mutation', incrementInventoryItem: { __typename?: 'InventoryItemPayload', inventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type GradeInventoryItemMutationVariables = Types.Exact<{
  input: Types.GradeInventoryItemCommandInput;
}>;


export type GradeInventoryItemMutation = { __typename?: 'Mutation', gradeInventoryItem: { __typename?: 'InventoryItemGradePayload', sourceInventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, destinationInventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type MoveInventoryItemMutationVariables = Types.Exact<{
  input: Types.MoveInventoryItemCommandInput;
}>;


export type MoveInventoryItemMutation = { __typename?: 'Mutation', moveInventoryItem: { __typename?: 'InventoryItemMovePayload', sourceInventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, destinationInventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type TransferInventoryItemMutationVariables = Types.Exact<{
  input: Types.TransferInventoryItemCommandInput;
}>;


export type TransferInventoryItemMutation = { __typename?: 'Mutation', transferInventoryItem: { __typename?: 'InventoryItemTransferPayload', sourceInventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, destinationInventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetInventoryItemReadyDateMutationVariables = Types.Exact<{
  input: Types.SetInventoryItemReadyDateCommandInput;
}>;


export type SetInventoryItemReadyDateMutation = { __typename?: 'Mutation', setInventoryItemReadyDate: { __typename?: 'InventoryItemPayload', inventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetInventoryBatchPlantDateMutationVariables = Types.Exact<{
  input: Types.SetInventoryBatchPlantDateInput;
}>;


export type SetInventoryBatchPlantDateMutation = { __typename?: 'Mutation', setInventoryBatchPlantDate: { __typename?: 'InventoryItemPayload', inventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ScrapInventoryItemMutationVariables = Types.Exact<{
  input: Types.ScrapInventoryItemCommandInput;
}>;


export type ScrapInventoryItemMutation = { __typename?: 'Mutation', scrapInventoryItem: { __typename?: 'InventoryItemPayload', inventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddInventoryNoteMutationVariables = Types.Exact<{
  input: Types.AddInventoryNoteInput;
}>;


export type AddInventoryNoteMutation = { __typename?: 'Mutation', addInventoryNote: { __typename?: 'InventoryItemPayload', inventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, notes: Array<{ __typename?: 'InventoryNoteData', noteId: string, submitDate: Types.TDateISO, submittedBy: string, text: string }>, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearInventoryNoteMutationVariables = Types.Exact<{
  input: Types.ClearInventoryNoteInput;
}>;


export type ClearInventoryNoteMutation = { __typename?: 'Mutation', clearInventoryNote: { __typename?: 'InventoryItemPayload', inventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, notes: Array<{ __typename?: 'InventoryNoteData', noteId: string, submitDate: Types.TDateISO, submittedBy: string, text: string }>, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReleaseInventoryHoldMutationVariables = Types.Exact<{
  input: Types.ReleaseInventoryHoldInput;
}>;


export type ReleaseInventoryHoldMutation = { __typename?: 'Mutation', releaseInventoryHold: { __typename?: 'InventoryItemPayload', inventoryItem?: { __typename?: 'InventoryItemStateData', heldQuantity: number, generalQuantity: number, availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, customerHolds: Array<{ __typename?: 'InventoryCustomerHold', customerItemId: string, customerId: string, customerName: string, customerSku: string, customerUpc?: string | null, quantity: number }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateInventoryItemDocument = new TypedDocumentString(`
    mutation CreateInventoryItem($input: CreateInventoryItemCommandInput!) {
  createInventoryItem(input: $input) {
    inventoryItem {
      ...InventoryItemStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const AdjustInventoryItemDocument = new TypedDocumentString(`
    mutation AdjustInventoryItem($input: SetInventoryItemInput!) {
  adjustInventoryItem(input: $input) {
    inventoryItem {
      ...InventoryItemStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const IncrementInventoryItemDocument = new TypedDocumentString(`
    mutation IncrementInventoryItem($input: IncrementInventoryItemInput!) {
  incrementInventoryItem(input: $input) {
    inventoryItem {
      ...InventoryItemStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const GradeInventoryItemDocument = new TypedDocumentString(`
    mutation GradeInventoryItem($input: GradeInventoryItemCommandInput!) {
  gradeInventoryItem(input: $input) {
    sourceInventoryItem {
      ...InventoryItemStateFields
    }
    destinationInventoryItem {
      ...InventoryItemStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const MoveInventoryItemDocument = new TypedDocumentString(`
    mutation MoveInventoryItem($input: MoveInventoryItemCommandInput!) {
  moveInventoryItem(input: $input) {
    sourceInventoryItem {
      ...InventoryItemStateFields
    }
    destinationInventoryItem {
      ...InventoryItemStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const TransferInventoryItemDocument = new TypedDocumentString(`
    mutation TransferInventoryItem($input: TransferInventoryItemCommandInput!) {
  transferInventoryItem(input: $input) {
    sourceInventoryItem {
      ...InventoryItemStateFields
    }
    destinationInventoryItem {
      ...InventoryItemStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const SetInventoryItemReadyDateDocument = new TypedDocumentString(`
    mutation SetInventoryItemReadyDate($input: SetInventoryItemReadyDateCommandInput!) {
  setInventoryItemReadyDate(input: $input) {
    inventoryItem {
      ...InventoryItemStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const SetInventoryBatchPlantDateDocument = new TypedDocumentString(`
    mutation SetInventoryBatchPlantDate($input: SetInventoryBatchPlantDateInput!) {
  setInventoryBatchPlantDate(input: $input) {
    inventoryItem {
      ...InventoryItemStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const ScrapInventoryItemDocument = new TypedDocumentString(`
    mutation ScrapInventoryItem($input: ScrapInventoryItemCommandInput!) {
  scrapInventoryItem(input: $input) {
    inventoryItem {
      ...InventoryItemStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const AddInventoryNoteDocument = new TypedDocumentString(`
    mutation AddInventoryNote($input: AddInventoryNoteInput!) {
  addInventoryNote(input: $input) {
    inventoryItem {
      ...InventoryItemStateFields
      notes {
        noteId
        submitDate
        submittedBy
        text
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const ClearInventoryNoteDocument = new TypedDocumentString(`
    mutation ClearInventoryNote($input: ClearInventoryNoteInput!) {
  clearInventoryNote(input: $input) {
    inventoryItem {
      ...InventoryItemStateFields
      notes {
        noteId
        submitDate
        submittedBy
        text
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const ReleaseInventoryHoldDocument = new TypedDocumentString(`
    mutation ReleaseInventoryHold($input: ReleaseInventoryHoldInput!) {
  releaseInventoryHold(input: $input) {
    inventoryItem {
      ...InventoryItemStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InventoryItemStateFields on InventoryItemStateData {
  heldQuantity
  generalQuantity
  customerHolds {
    ...InventoryCustomerHoldFields
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment InventoryCustomerHoldFields on InventoryCustomerHold {
  customerItemId
  customerId
  customerName
  customerSku
  customerUpc
  quantity
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateInventoryItem: build.mutation<CreateInventoryItemMutation, CreateInventoryItemMutationVariables>({
      query: (variables) => ({ document: CreateInventoryItemDocument, variables })
    }),
    AdjustInventoryItem: build.mutation<AdjustInventoryItemMutation, AdjustInventoryItemMutationVariables>({
      query: (variables) => ({ document: AdjustInventoryItemDocument, variables })
    }),
    IncrementInventoryItem: build.mutation<IncrementInventoryItemMutation, IncrementInventoryItemMutationVariables>({
      query: (variables) => ({ document: IncrementInventoryItemDocument, variables })
    }),
    GradeInventoryItem: build.mutation<GradeInventoryItemMutation, GradeInventoryItemMutationVariables>({
      query: (variables) => ({ document: GradeInventoryItemDocument, variables })
    }),
    MoveInventoryItem: build.mutation<MoveInventoryItemMutation, MoveInventoryItemMutationVariables>({
      query: (variables) => ({ document: MoveInventoryItemDocument, variables })
    }),
    TransferInventoryItem: build.mutation<TransferInventoryItemMutation, TransferInventoryItemMutationVariables>({
      query: (variables) => ({ document: TransferInventoryItemDocument, variables })
    }),
    SetInventoryItemReadyDate: build.mutation<SetInventoryItemReadyDateMutation, SetInventoryItemReadyDateMutationVariables>({
      query: (variables) => ({ document: SetInventoryItemReadyDateDocument, variables })
    }),
    SetInventoryBatchPlantDate: build.mutation<SetInventoryBatchPlantDateMutation, SetInventoryBatchPlantDateMutationVariables>({
      query: (variables) => ({ document: SetInventoryBatchPlantDateDocument, variables })
    }),
    ScrapInventoryItem: build.mutation<ScrapInventoryItemMutation, ScrapInventoryItemMutationVariables>({
      query: (variables) => ({ document: ScrapInventoryItemDocument, variables })
    }),
    AddInventoryNote: build.mutation<AddInventoryNoteMutation, AddInventoryNoteMutationVariables>({
      query: (variables) => ({ document: AddInventoryNoteDocument, variables })
    }),
    ClearInventoryNote: build.mutation<ClearInventoryNoteMutation, ClearInventoryNoteMutationVariables>({
      query: (variables) => ({ document: ClearInventoryNoteDocument, variables })
    }),
    ReleaseInventoryHold: build.mutation<ReleaseInventoryHoldMutation, ReleaseInventoryHoldMutationVariables>({
      query: (variables) => ({ document: ReleaseInventoryHoldDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateInventoryItemMutation, useAdjustInventoryItemMutation, useIncrementInventoryItemMutation, useGradeInventoryItemMutation, useMoveInventoryItemMutation, useTransferInventoryItemMutation, useSetInventoryItemReadyDateMutation, useSetInventoryBatchPlantDateMutation, useScrapInventoryItemMutation, useAddInventoryNoteMutation, useClearInventoryNoteMutation, useReleaseInventoryHoldMutation } = injectedRtkApi;
